// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3xHC_","colMaxWidth":"Table_colMaxWidth__ECPx-"};